import { oc } from "@orpc/contract";
import { z } from "zod";

export const errorSchema = z.object({
  error: z.object({ code: z.string(), message: z.string() }),
});
export const errorStatusMap = {
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  ADMIN_STEP_UP_REQUIRED: 401,
  LAST_ADMIN: 409,
  ADMIN_TARGET_NO_LOGIN: 409,
  ADMIN_FACTOR_REQUIRED: 409,
  TARGET_IS_ADMIN: 409,
  SECURITY_RECONCILIATION_REQUIRED: 503,
  PAYMENT_REQUIRED: 402,
  FORBIDDEN: 403,
  IMPERSONATION_READ_ONLY: 403,
  NOT_FOUND: 404,
  METHOD_NOT_ALLOWED: 405,
  CONFLICT: 409,
  TOO_MANY_REQUESTS: 429,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
};

export const readContract = oc.input(z.strictObject({})).errors({
  BAD_REQUEST: { message: "Invalid request" },
  NOT_FOUND: { message: "Not Found" },
  METHOD_NOT_ALLOWED: { message: "Method Not Allowed" },
  INTERNAL_SERVER_ERROR: { message: "Internal Server Error" },
});
